import type { ReactNode } from 'react';

import { Button } from '@keboola/design';

import { isSaveDisabled, type SaveButtonState } from './saveButtonState';

type Props = {
  state: SaveButtonState;
  /** The `<form>`'s `id`, for a button outside it (modal footers are siblings of the form). */
  form?: string;
  children?: ReactNode;
};

/**
 * Submit button for an edit form; disabled while the form is unchanged.
 *
 * - Not `form.SubmitButton`: it omits `disabled` from its props, so the pristine rule can't be added.
 * - Creation forms keep `form.SubmitButton` — a blank form is always pristine.
 * - `state` comes from the caller's `form.Subscribe`; design does not export `useFormContext`.
 */
export const SaveButton = ({ state, form, children = 'Save' }: Props) => (
  <Button type="submit" form={form} isLoading={state.isSubmitting} disabled={isSaveDisabled(state)}>
    {children}
  </Button>
);
